module.exports = __webpack_public_path__ + "img/icon.ca93d755.png";